
import React from 'react';
import './Home.css';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

import {
  FaClipboardCheck,
  FaStore,
  FaFileMedical,
  FaFileSignature,
  FaCheckCircle,
  FaBuilding,
  FaChair,
  FaPhone,
  FaUserCheck,
  FaClock,
  FaHandshake,
  FaSearch,
  FaFileAlt,
  FaLandmark,
  FaArrowLeft,
  FaLightbulb
} from 'react-icons/fa';

const services = [
  {
    text: 'תכנון העסק והכנתו לתהליך הרישוי',
    icon: <FaClipboardCheck />
  },
  {
    text: 'התאמת העסק והדרכה בהתאם לצו רישוי עסקים',
    icon: <FaStore />
  },
  {
    text: 'קידום אישורים מול הרשויות המקומיות',
    icon: <FaBuilding />
  },
  {
    text: 'ליווי בקבלת אישור משרד הבריאות',
    icon: <FaFileMedical />
  },
  {
    text: 'היתרי שולחנות וכיסאות וסגירות חורף',
    icon: <FaChair />
  }
];

const openingSteps = [
  {
    number: '01',
    title: 'מגדירים את סוג העסק',
    description:
      'מתחילים בהבנת הפעילות המתוכננת, סוג העסק, השירותים שיינתנו בו ואופי העבודה. פרטים אלה מסייעים להבין אילו דרישות עשויות לחול על העסק.',
    icon: <FaStore />
  },
  {
    number: '02',
    title: 'בודקים את דרישות הרישוי',
    description:
      'בודקים האם הפעילות טעונה רישיון עסק, מהו פריט הרישוי המתאים ומהן הדרישות הרלוונטיות בהתאם לצו רישוי עסקים ולרשות המקומית.',
    icon: <FaSearch />
  },
  {
    number: '03',
    title: 'בודקים התאמה של הנכס',
    description:
      'לפני חתימה על חוזה או ביצוע שיפוץ, חשוב לבדוק את התאמת הנכס והשימוש המתוכנן בו לדרישות התכנון, הבנייה והרישוי.',
    icon: <FaBuilding />
  },
  {
    number: '04',
    title: 'מכינים מסמכים ותוכניות',
    description:
      'בהתאם לסוג העסק ולדרישות הרשות, מכינים את המסמכים, התוכניות והאישורים הנדרשים לצורך הגשת בקשה לרישיון עסק.',
    icon: <FaFileAlt />
  },
  {
    number: '05',
    title: 'מגישים בקשה ומקדמים אישורים',
    description:
      'מגישים את הבקשה ופועלים לקידום האישורים מול הגורמים הרלוונטיים. הדרישות והשלבים משתנים בהתאם לסוג העסק ולמאפייני הנכס.',
    icon: <FaFileSignature />
  }
];

const benefits = [
  {
    title: 'ליווי אישי',
    description: 'יחס אישי והכוונה לאורך שלבי תהליך הרישוי.',
    icon: <FaUserCheck />
  },
  {
    title: 'חיסכון בזמן',
    description: 'עושים סדר בדרישות ומסייעים להתנהל מול הגורמים הרלוונטיים.',
    icon: <FaClock />
  },
  {
    title: 'מקצועיות וניסיון',
    description: 'ניסיון של למעלה מעשור והיכרות עם תהליכי עבודה מול רשויות מקומיות רבות.',
    icon: <FaHandshake />
  }
];

export const Home = () => {
  return (
    <Container fluid className="home-page">
      <div className="home-content">

        <Fade bottom>
          <section className="home-hero" aria-labelledby="home-main-title">

            <div className="hero-label">
              <span className="hero-label-icon">
                <FaCheckCircle />
              </span>
              ליווי מקצועי בתהליך רישוי עסקים
            </div>

            <h1 id="home-main-title" className="hero-title">
              רישוי העסק שלך
              <span>מתחיל כאן</span>
            </h1>

            <p className="hero-description">
              מקימים עסק? מחדשים רישיון? מתכננים לפתוח מקום חדש?
              <br />
              אנחנו כאן כדי לעשות לכם סדר בתהליך רישוי העסק
              וללוות אתכם מול הרשויות.
            </p>

            <div className="hero-highlights">
              <div className="hero-highlight">
                <span className="highlight-icon">
                  <FaStore />
                </span>
                <span>מקימים עסק</span>
              </div>

              <div className="hero-highlight">
                <span className="highlight-icon">
                  <FaFileSignature />
                </span>
                <span>מחדשים רישיון</span>
              </div>

              <div className="hero-highlight">
                <span className="highlight-icon">
                  <FaCheckCircle />
                </span>
                <span>מקבלים ליווי מקצועי</span>
              </div>
            </div>

            <div className="hero-image">
              <img
                src="/1.png"
                alt="ליווי מקצועי בתהליך הוצאת רישיון עסק"
                fetchPriority="high"
              />

              <div className="hero-image-overlay"></div>

              <div className="hero-image-text">
                <h2>אתם מתמקדים בעסק</h2>
                <p>אנחנו נעזור לכם להתמודד עם הבירוקרטיה.</p>
              </div>
            </div>

          </section>
        </Fade>
        <Fade bottom>
          <section
            className="shani-section"
            aria-labelledby="shani-title"
          >

            <div className="shani-image-wrapper">

              <img
                src="/shani.png"
                alt="שני אדרעי – מומחית לרישוי עסקים וליווי מול הרשויות"
                className="shani-image"
                loading="lazy"
              />

              <div className="shani-experience">
                <strong>10+</strong>
                <span>שנות ניסיון בתחום</span>
              </div>

            </div>

            <div className="shani-content">

              <div className="section-eyebrow">
                ליווי אישי, ניסיון והיכרות עם הרשויות
              </div>

              <h2 id="shani-title">
                נעים להכיר,
                <span>אני שני אדרעי</span>
              </h2>

              <p>
                אני מומחית בתחום רישוי העסקים, עם למעלה מ־10 שנות ניסיון
                בליווי עסקים מול הרשויות בישראל.
              </p>

              <p>
                לאורך השנים צברתי ניסיון רב והיכרות מעמיקה עם דרכי
                העבודה והדרישות של רשויות מקומיות רבות, לצד הגורמים
                המקצועיים המעורבים בתהליך הרישוי.
              </p>

              <p>
                אני כאן כדי לעזור לכם להבין מה נדרש עבור העסק שלכם,
                לעשות סדר בבירוקרטיה, לקדם את הבקשות והאישורים הנדרשים
                וללוות אתכם בדרך לפתיחת העסק.
              </p>

              <p className="shani-highlight">
                המטרה שלי היא שתוכלו לפתוח את העסק בראש שקט,
                בידיעה שיש לכם אשת מקצוע מנוסה שמלווה אתכם לאורך הדרך.
              </p>


            </div>

          </section>
        </Fade>

        <Fade bottom>
          <section className="home-intro" aria-labelledby="intro-title">

            <div className="section-eyebrow">
              רישוי עסקים בישראל
            </div>

            <h2 id="intro-title" className="section-title">
              רישוי עסקים – פשוט יותר, מקצועי יותר
            </h2>

            <p className="section-description">
              תהליך הוצאת רישיון עסק עשוי לכלול דרישות, מסמכים ואישורים
              ממספר גורמים. השירות שלנו כולל ליווי אישי, מקצועי ומסודר,
              תוך בחינת מאפייני העסק והתאמת תהליך העבודה לדרישות החוק
              והרשויות הרלוונטיות.
            </p>

          </section>
        </Fade>

        <Fade bottom>
          <section
            className="opening-guide"
            aria-labelledby="opening-guide-title"
          >

            <div className="guide-heading">

              <div className="section-eyebrow">
                מתכננים לפתוח עסק?
              </div>

              <h2 id="opening-guide-title" className="section-title">
                מדריך ראשוני לפתיחת עסק ורישוי עסקים
              </h2>

              <p className="section-description">
                לפני שפותחים עסק, חשוב להבין מה נדרש כדי להפעיל אותו
                בצורה מסודרת ובהתאם לדרישות הרישוי. אלה השלבים הראשונים
                שכדאי להכיר.
              </p>

            </div>

            <div className="opening-steps">

              {openingSteps.map((step) => (
                <article className="opening-step" key={step.number}>

                  <div className="step-top">
                    <span className="step-number">
                      {step.number}
                    </span>

                    <span className="step-icon">
                      {step.icon}
                    </span>
                  </div>

                  <h3>{step.title}</h3>
                  <p>{step.description}</p>

                </article>
              ))}

            </div>

            <div className="guide-notice">
              <FaLightbulb />

              <p>
                <strong>טיפ חשוב:</strong>
                {' '}
                אל תמהרו לחתום על חוזה שכירות או להתחיל בשיפוץ לפני
                שבדקתם את התאמת הנכס ואת דרישות הרישוי הרלוונטיות
                לסוג העסק שלכם.
              </p>
            </div>

            <div className="guide-cta">

              <p>
                לא בטוחים מאיפה מתחילים? אפשר לקבל הכוונה ראשונית.
              </p>

        

            </div>

          </section>
        </Fade>

        <Fade bottom>
          <section
            className="services-section"
            aria-labelledby="services-title"
          >

            <div className="section-eyebrow">
              מה אנחנו עושים?
            </div>

            <h2 id="services-title" className="section-title">
              השירותים שלנו בתחום רישוי עסקים
            </h2>

            <p className="section-description">
              מגוון שירותי ליווי, תכנון וקידום תהליכי רישוי לעסקים,
              בהתאם לאופי הפעילות ולדרישות הגורמים המוסמכים.
            </p>

            <div className="services-grid">

              {services.map((item, index) => (
                <article className="service-card" key={index}>

                  <div className="service-icon">
                    {item.icon}
                  </div>

                  <h3>{item.text}</h3>

                </article>
              ))}

            </div>

          </section>
        </Fade>

        <Fade bottom>
          <section
            className="why-section"
            aria-labelledby="why-title"
          >

            <div className="section-eyebrow">
              למה לעבוד איתנו?
            </div>

            <h2 id="why-title" className="section-title">
              ליווי מקצועי שעושה סדר בתהליך
            </h2>

            <div className="benefits-grid">

              {benefits.map((item, index) => (
                <article className="benefit-card" key={index}>

                  <div className="benefit-icon">
                    {item.icon}
                  </div>

                  <h3>{item.title}</h3>
                  <p>{item.description}</p>

                </article>
              ))}

            </div>

          </section>
        </Fade>


        <Fade bottom>
          <section
            className="home-cta"
            aria-labelledby="cta-title"
          >

            <div className="cta-icon">
              <FaLandmark />
            </div>

            <div className="section-eyebrow">
              העסק שלכם בדרך הנכונה
            </div>

            <h2 id="cta-title">
              מוכנים להתחיל?
            </h2>

            <p>
              פותחים עסק חדש? קיבלתם דרישה מהעירייה? זקוקים לסיוע
              בהוצאת רישיון עסק או בקידום אישורים מול הרשויות?
              <br />
              שני אדרעי כאן כדי לעזור לכם להבין את הדרישות,
              לעשות סדר בתהליך ולקדם את הבקשות הנדרשות,
              כדי שתוכלו להתמקד בעסק שלכם
            </p>

        


          </section>
        </Fade>

      </div>
    </Container>
  );
};

export default Home;
